
import { Component, OnInit, inject, input } from '@angular/core';
import { MatDialog, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { DxButtonModule } from 'devextreme-angular';

@Component({
    selector: 'app-dialog-top',
    templateUrl: './dialog-top.component.html',
    styleUrls: ['./dialog-top.component.scss'],
    imports: [MatDialogModule, DxButtonModule],
    host: {
        'class': 'd-flex mat-dialog-title'
    }
})
export class DialogTopComponent extends MatDialogTitle implements OnInit {

    readonly dialogRef = inject<MatDialogRef<any>>(MatDialogRef);
    readonly dialog = inject(MatDialog);

    public $overrideClose = input<null | ((dialogRef: MatDialogRef<any>) => void)>(null, { alias: 'overrideClose' });

    close() {
        const override = this.$overrideClose();
        if (!override)
            this.dialogRef && this.dialogRef.close();
        else
            override(this.dialogRef);
    }

}
